export const getColumnDefaultSortDirection = (columnName: string) => {
  switch (columnName) {
    case "location.name":
      return "asc";
    case "project_join_date":
      return "desc";
    case "location.location_stats.score":
      return "asc";
    default:
      return "asc";
  }
};
